"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

var _lodash = require("lodash.omit");

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = require("lodash.get");

var _lodash4 = _interopRequireDefault(_lodash3);

var _reducer = require("./reducer");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class HttpRequestHandler {
  constructor(_dispatch, _action, _getState, next, _config = HttpRequestHandler.defaultConfig) {
    _defineProperty(this, "generateRequestId", (length = 14) => Math.random().toString(length).replace('0.', ''));

    _defineProperty(this, "fireAnotherActions", actions => setTimeout(() => Promise.all(actions.map(action => this.dispatch(action))), 0));

    _defineProperty(this, "buildRequest", async () => {
      const {
        agent,
        getState,
        action,
        dispatch
      } = this;
      const {
        request
      } = action;
      return request(agent, {
        getState,
        dispatch
      });
    });

    _defineProperty(this, "parseActionsAfterSuccess", actions => {
      function parse(act) {
        act.map(action => {
          const newAction = action;
          if (newAction.request) newAction.request = newAction.request.toString();
          if (newAction.actionsAfterSuccess) parse(newAction.actionsAfterSuccess);
        });
      }

      parse(actions);
      return actions;
    });

    _defineProperty(this, "addRequestToQueue", async err => {
      const {
        actionsAfterSuccess,
        isSilentRequest,
        after,
        before,
        reducer
      } = this.action;
      const requestId = this.generateRequestId();
      let copiedRequest = { ...(0, _lodash2.default)(this.action, ['request', 'after', 'before', 'afterFailed']),
        preferRequest: { ...err.config,
          data: JSON.stringify((0, _lodash2.default)(JSON.parse(err.config.data || '{}')))
        }
      };

      if (reducer) {
        if (after) copiedRequest.after = after.name;
        if (before) copiedRequest.before = before.name;
      }

      if (actionsAfterSuccess) this.parseActionsAfterSuccess(actionsAfterSuccess);

      if (isSilentRequest) {
        copiedRequest = {
          preferRequest: copiedRequest.preferRequest
        };
      }

      this.dispatch((0, _reducer.addRequestToQueue)(requestId, copiedRequest));
    });

    _defineProperty(this, "ensureToSend", requestId => this.agent.interceptors.response.use(res => {
      if (requestId) this.dispatch((0, _reducer.removeRequestFromQueue)(requestId));
      return res;
    }, async err => {
      try {
        if (!requestId && err && err.message === 'Network Error') {
          await this.addRequestToQueue(err);
        } else if (requestId) this.dispatch((0, _reducer.removeRequestFromQueue)(requestId));
      } catch (err) {
        if (requestId) this.dispatch((0, _reducer.removeRequestFromQueue)(requestId));
      }

      return Promise.reject(err);
    }));

    _defineProperty(this, "getDataFromAction", () => (0, _lodash2.default)(this.action, HttpRequestHandler.reservedKeys));

    _defineProperty(this, "dataToTarget", data => {
      if (this.action.target) {
        return {
          [this.action.target]: data
        };
      }

      return data;
    });

    _defineProperty(this, "send", async () => {
      const {
        requestState,
        getState,
        action,
        dispatch,
        config,
        agent
      } = this;
      const {
        requestId,
        actionsAfterSuccess,
        before,
        isEnsureToSend,
        origin,
        onFailedRequest,
        waitForStart
      } = action;
      let timeoutForStart;
      if (origin) this.agent = _axios2.default.create({
        baseURL: origin,
        ...this.axiosConfig
      });
      if (config.hooks.before) config.hooks.before({
        action,
        getState,
        dispatch,
        agent
      });
      if (before) before(getState(), dispatch);
      if (isEnsureToSend) this.ensureToSend(requestId);

      if (requestState.START) {
        if (waitForStart) {
          timeoutForStart = setTimeout(() => {
            timeoutForStart = null;
            this.next({
              type: requestState.START,
              data: this.dataToTarget(config.defaultPayload.inProgress),
              ...this.getDataFromAction()
            });
          }, waitForStart);
        } else {
          this.next({
            type: requestState.START,
            data: this.dataToTarget(config.defaultPayload.inProgress),
            ...this.getDataFromAction()
          });
        }
      }

      try {
        const response = await this.buildRequest();
        if (timeoutForStart) clearTimeout(timeoutForStart);
        const data = this.action.target ? this.dataToTarget({
          response: response.data,
          ...config.defaultPayload.success
        }) : response.data;
        if (actionsAfterSuccess) this.fireAnotherActions(actionsAfterSuccess);
        if (requestState.SUCCESS) this.next({
          type: requestState.SUCCESS,
          data,
          ...this.getDataFromAction()
        });
        if (config.hooks.after) config.hooks.after({
          data,
          getState,
          dispatch
        });
        if (action.onSuccessRequest && response.status < 300) action.onSuccessRequest({
          data,
          store: {
            getState,
            dispatch
          }
        });
        if (onFailedRequest && response.status >= 400) onFailedRequest({
          response,
          store: {
            getState,
            dispatch
          }
        });
        return data;
      } catch (err) {
        if (config.hooks.afterFailed) config.hooks.afterFailed({
          err,
          getState,
          dispatch
        });
        if (onFailedRequest) onFailedRequest({
          response: err.request,
          store: {
            getState,
            dispatch
          }
        });

        if (requestState.FAILED) {
          this.next({
            type: requestState.FAILED,
            ...(err.request ? {
              status: err.request.status,
              message: err.request.statusText,
              body: err.request.body
            } : {}),
            data: this.dataToTarget({ ...config.defaultPayload.failed
            }),
            ...this.getDataFromAction()
          });
        } else if (err.request) {
          this.next({
            type: "common/REQUEST_FAILED",
            status: err.request.status,
            message: err.request.statusText,
            body: err.request.body
          });
        }

        return Promise.reject(err);
      }
    });

    const {
      types,
      type
    } = _action;
    this.requestState = types ? {
      START: types[0],
      SUCCESS: types[1] || type,
      FAILED: types[2]
    } : {
      SUCCESS: type
    };
    this.action = _action;
    this.dispatch = _dispatch;
    this.getState = _getState;
    this.config = { ...HttpRequestHandler.defaultConfig,
      ..._config
    };
    this.next = next;
    const axiosConfig = {};

    if (_action.isAuthReq && (0, _lodash4.default)(_getState(), _config.pathToToken)) {
      axiosConfig.headers = {
        "Authorization": `Bearer ${(0, _lodash4.default)(_getState(), _config.pathToToken)}`
      };
    }

    this.axiosConfig = axiosConfig;
    this.agent = _axios2.default.create({
      baseURL: _config.apiUrl || '',
      ...axiosConfig
    });
  }

}

exports.default = HttpRequestHandler;

_defineProperty(HttpRequestHandler, "reservedKeys", ['types', 'type', 'requestId', 'request', 'data', 'origin', 'actionsAfterSuccess', 'isAuthReq', 'before', 'isEnsureToSend', 'afterFailed']);

_defineProperty(HttpRequestHandler, "defaultConfig", {
  hooks: {},
  defaultPayload: {
    inProgress: {},
    success: {},
    failed: {}
  }
});